<template>
  <div>
    <b-navbar toggleable="lg" variant="light" align="end" class="nav mt-2 mb-2">
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
      <b-collapse id="nav-collapse" is-nav align="end">
        <b-navbar-nav class="ml-auto">
          <b-navbar-nav>
            <b-nav-item
              :to="{ name: 'admin.vehicles-price' }"
              :active="$route.name === 'admin.vehicles-price'"
            >
              Vehicles
            </b-nav-item>
            <b-nav-item
              :to="{ name: 'admin.providers-price' }"
              :active="$route.name === 'admin.providers-price'"
            >
              Providers
            </b-nav-item>
          </b-navbar-nav>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>
<script>
export default {
  name: "VehiclesProviderPriceView",
  data() {
    return {};
  },
  created() {
    this.$emit("set-status", "vehicles");
  },
  methods: {},
};
</script>
